import { Component, OnInit,AfterViewInit, ElementRef, ViewChild,
Input, OnChanges, OnDestroy, Output, SimpleChanges, EventEmitter } from '@angular/core';
//import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
//import * as InlineEditor from '@ckeditor/ckeditor5-build-inline';
//import * as Editor from '../ckeditor5/build/ckeditor';
import { InlineEditor, Autoformat, Bold, Essentials, Italic, List, Mention, Paragraph, Undo, type EditorConfig } from 'ckeditor5';
//import * as  from '@ckeditor/ckeditor5-build-decoupled-document';
import SimpleUploadAdDecoupledEditorapter from '@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular/ckeditor.component';
import {UploadService} from '../_services/index';
import {UploadAdapter} from '../uploadadapter';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import { InjectDirective } from '../_directive/inject.directive';

declare var $: any;
@Component({
  selector: 'app-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.css']
})
export class SectionComponent implements OnInit {
	@Input() order: string;
	@Input() index: string;
	@Input() getData:string;
	@Output() outHtml = new EventEmitter<string>();
  	public Editor = InlineEditor;//Editor;
	public ckconfig:any;
	public docs=[];
	public docList=[];
	public docIndex:number;
	public config={
		toolbar: {
					items: [
						'heading',
						'|',
						'bold',
						'italic',
						'link',
						'bulletedList',
						'numberedList',
						'|',
						'indent',
						'outdent',
						'|',
						'imageUpload',
						'blockQuote',
						'insertTable',
						'mediaEmbed',
						'undo',
						'redo',
						'alignment',
						'fontSize',
						'fontFamily',
						'horizontalLine'
					]
				},
				language: 'en',
				image: {
					toolbar: [
						'imageTextAlternative',
						'imageStyle:full',
						'imageStyle:side'
					]
				},
				table: {
					contentToolbar: [
						'tableColumn',
						'tableRow',
						'mergeTableCells'
					]
				}
		 
		
	};
	@ViewChild('myEditor') myEditor: any;
	constructor(private uls: UploadService, private http:HttpClient) { }

	ngOnInit(): void {
	}
	ngOnChanges(changes: SimpleChanges): void {
        if ('getData' in changes) {
			let data=this.getCKContent();
			this.outHtml.emit(data);
		}
	}
	onReady(eventData) {console.log(this.http);
	let that=this;
    eventData.plugins.get('FileRepository').createUploadAdapter = function (loader) {
		//console.log(that.http)
      console.log(btoa(loader.file));
      return new UploadAdapter(loader,that.http);
    };
		/*let content="";
		let order=["a",'b','c'];
		for(let item of order){
			content+='<p>'+item+'</p><span>'+item+'</span><span>'+item+'</span><span>'+item+'</span>';
		}
		
			content+='<div *ngFor="let item of '+order+'">'+
				'<p>{{item}}</p>'+
				'</div>'+
				'<table><tr><td>abc</td><td>abc</td><td>abc</td></tr>'+
				'<tr><td>bc</td><td>bc</td><td>bc</td></tr>'+
				'</table>';*/
				let content='<h1>'+this.order+'.'+this.index+' Section</h1>'
				eventData.setData(content);
	}	
	onChange({ editor }: ChangeEvent){
		//const data = editor.getData();
		//console.log(data);
		//this.outHtml.emit(data);
		
		
	}
	private getCKContent() {
    if (this.myEditor && this.myEditor.editorInstance) {
      return this.myEditor.editorInstance.getData();
    }

    return '';
  }
}
